import api from "./Api";

class MotoristaEmailService {
  GetMotoristaEmail(payload) {
    return api.get("/v1/motoristaEmail/" + payload).then((response) => {
      return response.data;
    });
  }

  PostMotoristaEmail(payload) {
    return api.post("/v1/motoristaEmail/", payload).then((response) => {
      return response.data;
    });
  }

  PutMotoristaEmail(payload) {
    return api.put("/v1/motoristaEmail/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteMotoristaEmail(payload) {
    return api.delete("/v1/motoristaEmail/" + payload).then((response) => {
      return response.data;
    });
  }

  GetMotoristaEmailOData(payload) {
    return api.get("/OData/MotoristaEmail" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new MotoristaEmailService();
